/**
 * @generated SignedSource<<1f541c5c838034f59fc7edebb9ce7eaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ModelColorMappingInput = {
  colorID: number;
  merchantCode: string;
  salesChannelID: string;
};
export type variantsSetModelColorMappingMutation$variables = {
  modelColorMappings: ReadonlyArray<ModelColorMappingInput>;
  modelID: string;
};
export type variantsSetModelColorMappingMutation$data = {
  readonly setModelColorMapping: ReadonlyArray<{
    readonly colorID: number;
    readonly merchantCode: string;
  }> | null;
};
export type variantsSetModelColorMappingMutation = {
  response: variantsSetModelColorMappingMutation$data;
  variables: variantsSetModelColorMappingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelColorMappings"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelID"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "modelColorMappings",
        "variableName": "modelColorMappings"
      },
      {
        "kind": "Variable",
        "name": "modelID",
        "variableName": "modelID"
      }
    ],
    "concreteType": "ModelColorMapping",
    "kind": "LinkedField",
    "name": "setModelColorMapping",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "colorID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "merchantCode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "variantsSetModelColorMappingMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "variantsSetModelColorMappingMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "cab35118ef185542be4535f0cda8af39",
    "id": null,
    "metadata": {},
    "name": "variantsSetModelColorMappingMutation",
    "operationKind": "mutation",
    "text": "mutation variantsSetModelColorMappingMutation(\n  $modelID: ID!\n  $modelColorMappings: [ModelColorMappingInput!]!\n) {\n  setModelColorMapping(modelID: $modelID, modelColorMappings: $modelColorMappings) {\n    colorID\n    merchantCode\n  }\n}\n"
  }
};
})();

(node as any).hash = "bf9ca0c3acc4a127611be38f7e3baae9";

export default node;
